import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Create a single Pinia instance for all app instances
const pinia = createPinia()

/**
 * Creates a Vue instance for each element matching the selector.
 * @param {string} selector - CSS selector
 * @param {Object} options - Vue instance options
 * @param {function} setup - Optional setup function to execute on Vue instance
 */
function createVueInstance(selector, options, setup) {
  const elements = Array.from(document.querySelectorAll(selector))
  elements.forEach(element => {
    const app = createApp(options)
    app.config.globalProperties.window = window
    app.use(pinia)

    if (setup) {
      setup(app)
    }

    app.mount(element)
  });
}

// Create and intialize app on each vue instance element

import ChpPhysiciansSearchInput from './components/ChpPhysiciansSearchInput.vue'
import ChpPhysiciansLastNameFilter from './components/ChpPhysiciansLastNameFilter.vue'
import ChpPhysiciansFilters from './components/ChpPhysiciansFilters.vue'
import ChpPhysiciansResults from './components/ChpPhysiciansResults.vue'
import ChpPhysicianSearchWidgetFilters from './components/ChpPhysicianSearchWidgetFilters.vue'
import ChpPhysicianSearchWidgetResults from './components/ChpPhysicianSearchWidgetResults.vue'
import Pagination from './components/Pagination.vue'
import SearchResults from './components/SearchResults.vue'
import AnimateNumber from './components/AnimateNumber.vue'

createVueInstance(
  '#physiciansSearchInput',
  {
    components: {
      ChpPhysiciansSearchInput
    }
  }
)

createVueInstance(
  '#physiciansLastNameFilter',
  {
    components: {
      ChpPhysiciansLastNameFilter
    }
  }
)

createVueInstance(
  '#physiciansFilters',
  {
    components: {
      ChpPhysiciansFilters
    }
  }
)

createVueInstance(
  '#physiciansResults',
  {
    components: {
      ChpPhysiciansResults
    }
  }
)

createVueInstance(
  '#physiciansPagination',
  {
    components: {
      Pagination
    }
  }
)

createVueInstance(
  '#physicianSearchWidgetFilters',
  {
    components: {
      ChpPhysicianSearchWidgetFilters
    }
  }
)

createVueInstance(
  '#physicianSearchWidgetResults',
  {
    components: {
      ChpPhysicianSearchWidgetResults
    }
  }
)

createVueInstance(
  '#physicianSearchWidgetPagination',
  {
    components: {
      Pagination
    }
  }
)

createVueInstance(
  '#searchResults',
  {
    components: {
      SearchResults
    }
  }
)

createVueInstance(
  '#statNumber',
  {
    components: {
      AnimateNumber
    }
  }
)
